import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";
import Text from "@components/AppText";
import { normalize, width } from "@utils/metrics";
import AddressIcon from "@assets/svg/Profile/AddressIcon";
import { useNavigation } from "@react-navigation/native";
import {
  PROFILE_EVENTS,
  PROFILE_EVENT_SOURCES,
} from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import { useSelector } from "react-redux";
import withLocation from "@utils/withLocation";
import t from "@constants/localization";
import EditIcon from "@assets/svg/EditIcon";
import LocationPin from "./LocationPin";

const PATH = "components/Profile/AddressSection";

const AddressSection = (props) => {
  const navigation = useNavigation();
  const {
    address1,
    address2,
    landmark,
    pincode,
    city,
    state,
    name,
    supportTicket,
    phone_number,
  } = useSelector(({ auth: { user } }) => user);

  const formAddress = () => {
    return [address1, address2, landmark, pincode, city, state]
      .filter(
        (el, _) =>
          el !== "" &&
          el !== " " &&
          typeof el !== "undefined" &&
          el !== null &&
          el?.length > 0,
      )
      .join(", ");
  };

  let hasAddress = true;
  const addressCheckProps = [address1, city];
  addressCheckProps.map((prop) => {
    if (typeof prop === "string" && prop.trim() === "") {
      hasAddress = false;
    }
  });

  return (
    <>
      <View
        style={{
          marginHorizontal: normalize(16),
          borderWidth: 0.5,
          borderColor: "rgba(0, 0, 0, 0.20)",
          padding: normalize(14),
          borderRadius: 6,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              paddingVertical: normalize(4),
            }}
          >
            <LocationPin />
            <Text
              style={{
                fontSize: 14,
                fontFamily: "NotoSansDevanagari-Bold",
                marginHorizontal: 5,
              }}
            >
              {t(`${PATH}/yourAddress`)}
            </Text>
          </View>
          <TouchableOpacity
            onPress={() => {
              analytics.trackEvent(PROFILE_EVENTS.PROFILE_EDIT, {
                section: PROFILE_EVENT_SOURCES.ADDRESS,
              });
              props.getLocationAndNavigate();
            }}
          >
            <EditIcon />
          </TouchableOpacity>
        </View>
        <View style={{ maxWidth: normalize(260) }}>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "NotoSansDevanagari-Regular",
              textTransform: "capitalize",
            }}
            numberOfLines={2}
          >
            {formAddress()}
          </Text>
        </View>
      </View>
    </>
  );
};

export default withLocation(AddressSection, {
  fromSignUp: false,
  fromDrawer: false,
  fromProfile: true,
});
